 import React, { Component, Fragment} from 'react';
// import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import cx from '../../../styles';
import {Icon} from '../../Common/Icon';
import {gtmSend} from '../../../helpers';

class ForgotPassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isRegisteredEmail: false,
            isValid: false,//check if valid email
            isResetPressed: false,
            wait: false, //to show loader if checking registered from api
            isMailSent: false,
            isMailChecked: false,
            email: ''            
        };
    }

    componentDidMount(){
        gtmSend('dynamic', 'forgot password form', 'show', '');
    }

    //Check if email is valid and registered
    sendEmail = () => {
        if(this.validateEmail(this.state.email)) {
            this.setState({ isValid: true, wait: true, isMailChecked: true });

            this.props.emailCheck( this.state.email, (emailCount) => {
                if(emailCount > 0) {
                    this.setState({ isRegisteredEmail: true, wait: false })

                    if(!this.state.isMailSent) {
                        //if email valid and registered send mail
                        this.setState({isMailSent: true})
                        this.props.onForgotPassword(this.state.email);
                    }
                }
                else {
                    this.setState({ isRegisteredEmail: false, wait: false })
                }
            })
        }
        else{
            this.setState({ isValid: false});
        }
    }

    onForgotPasswordSubmit = (e) => {
        e.preventDefault();
        this.setState({ isResetPressed: true});
        gtmSend('dynamic', 'reset forgot password', 'click', '');
        
        //If once checked will not check the email again
        if(!this.state.isMailChecked){
            this.sendEmail();
        } 
        // if(!this.state.isMailSent && this.state.isRegisteredEmail){
        //         console.log('call forgot api');
        //         this.props.onForgotPassword(this.state.email);
        //         this.setState({isMailSent: true})   
        //     }
        
    }

    onEmailChange = (email) => {
        this.setState({email, isResetPressed: false, isRegisteredEmail: false, isMailChecked: false});
    }

    validateEmail = (email) => {
        const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return re.test(String(email).toLowerCase());
    }

    render() {
        const t = this.props.t;

        return (
            <div className={cx('forgot-password-wrap')}>
                <div className={cx("close-modal",'forgot-password-close')} onClick={() => this.props.onResetClick(false)}>
                    <Icon className={cx("not-mobile")} name="close-regular-black-sm" />
                    <Icon className={cx("only-mobile")}  name="cross-regular-dark-smd" />
                </div>
                <span className={cx('reset-password-title')}>{t('lets_find_your_asianparent_password')}</span>
                <span className={cx('reset-password-text')}>{t('whats_your_email_address')}</span>
                    <form className={cx('forgot-password-form')} onSubmit={this.onForgotPasswordSubmit}>
                        <div className={cx('email-wrap')}>
                            <input className="input_email" type="text" placeholder={t('email')} onChange={e => this.onEmailChange(e.target.value)} autoComplete="off" />
                        </div>
                        {
                            !this.state.isMailSent 
                            ?
                            <div className={cx('reset-btn')}>
                                <button className={cx("btn", "btn-primary")} type="submit"><span className={cx('reset-btn-text')}>{t('reset')}</span>
                                {
                                    this.state.isValid && this.state.isResetPressed && !this.state.isRegisteredEmail && this.state.wait && 
                                    <span className={cx("spinner")}></span>
                                }
                                </button>
                            </div>
                            :
                            <div className={cx('reset-btn')}>
                                <button className={cx("btn", "btn-primary")} onClick={()=> this.props.onResetClick(false)}><span>{t('back_to_login')}</span></button>
                            </div>
                        }
                    </form>
                {
                    //Msg if couldn't find a registered email 
                    this.state.isResetPressed && !this.state.isRegisteredEmail && !this.state.wait && this.state.isValid &&
                    <Fragment>
                        <Icon name='info-black-round-icon' />
                        <div className={cx('error-msg-wrap')}>{t('couldnt_find_acount_with_this_email')}</div>
                    </Fragment>
                }
                {
                    //Msg if the email entered is not valid
                    this.state.isResetPressed && !this.state.isValid && 
                    <Fragment>
                        <Icon name='info-black-round-icon' />
                        <div className={cx('error-msg-wrap')}>{t('please_enter_valid_email')}</div>
                    </Fragment>
                }
                {
                    //Reset mail sent successfully
                    this.state.isResetPressed && this.state.isRegisteredEmail && this.state.isValid &&
                    <div className={cx('error-msg-wrap')}>{t('sent_email_to')}<span className={cx('email-msg')}>{this.state.email}</span> {t('so_you_can_set_new_password')}</div>
                }
            </div>
        );
    }

}


export default translate()(ForgotPassword);